import ButtonLoading from '~/components/Shared/ButtonLoading';

/**
 * @typedef {Object} ButtonProps
 * @property {'primary' | 'success' | 'warning' | 'danger' | 'discard'} [type] - Button type/style variant
 * @property {boolean} [small] - Whether to render a small button
 * @property {boolean} [round] - Whether to render rounded corners
 * @property {React.ReactNode} children - Button content
 * @property {string} [className] - Additional CSS class names
 * @property {boolean} [loading] - Whether to show loading state
 */

/**
 * Button component with various style options and loading state
 * @param {ButtonProps & React.HTMLProps<HTMLButtonElement>} props
 */
export default function Button({type, small = false, round = false, children, className = "", loading = false, ...props}) {
    const classNames = ['btn'];

    if (type) {
        classNames.push(`btn-${type}`);
    } else {
        classNames.push('btn-discard'); // dark border, no fill
    }

    if (small) {
        classNames.push('btn-sm');
    }

    if (round) {
        classNames.push('btn-rounded');
    }

    return (
        <button className={classNames.join(' ') + " " + className} {...props}>
            {loading ? <ButtonLoading/> : children}
        </button>
    )
}